import { useCallback } from 'react';

import { useAutomatedBreaksContext } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AutomatedBreaksProvider/AutomatedBreaksProvider';
import SelectAutomatedBreakView from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/SelectAutomatedBreakView/SelectAutomatedBreakView';
import ClockedViewWithTaskWrapper from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/ClockedViewWithTaskWrapper/ClockedViewWithTaskWrapper';
import BackTooSoonView from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/BackTooSoonView/BackTooSoonView';
import AttestationView from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AttestationView/AttestationView';

const ClockedInViewWithAutomatedBreaks = () => {
  const { automatedBreakScreen } = useAutomatedBreaksContext();

  const renderContent = useCallback(() => {
    switch (automatedBreakScreen) {
      case 'clockedIn':
        return <ClockedViewWithTaskWrapper />;

      case 'selectAutomatedBreak':
        return <SelectAutomatedBreakView />;

      case 'backTooSoon':
        return <BackTooSoonView />;

      case 'attestation':
        return <AttestationView />;

      default:
        return <ClockedViewWithTaskWrapper />;
    }
  }, [automatedBreakScreen]);

  return renderContent();
};

export default ClockedInViewWithAutomatedBreaks;
